import { reactive } from "vue";
import {
  ClassItem,
  ClassGroupItem,
  MarkupType,
  ObjectItem,
  ObjectType,
  Source,
  Storage,
  Tag,
} from "../../models";

export interface DatasetStateInterface {
  inited: boolean;
  cacheObjectItems: ObjectItem[];
  objectItems: ObjectItem[];
  objectTypes: ObjectType[];
  storages: Storage[];
  sources: Source[];
  tags: Tag[];
  classes: ClassItem[];
  classGroups: ClassGroupItem[];
  markupTypes: MarkupType[];
}

function state(): DatasetStateInterface {
  return {
    inited: false,
    cacheObjectItems: [],
    objectItems: reactive<ObjectItem[]>([]),
    objectTypes: [],
    storages: [],
    sources: [],
    tags: reactive<Tag[]>([]),
    classes: reactive<ClassItem[]>([]),
    classGroups: reactive<ClassGroupItem[]>([]),
    markupTypes: [],
  };
}

export default state;
